import { useNavigate } from 'react-router-dom'

export const BackButton = () => {
  const navigate = useNavigate()

  function handleBackButton() {
    const currentPath = location.pathname.split('/').filter(Boolean)
    if (currentPath.length > 1) {
      currentPath.pop()
      navigate(`/${currentPath.join('/')}`)
    }
  }

  return (
    <button
      type="button"
      onClick={handleBackButton}
      className="me-8 text-2xl cursor-pointer text-[var(--brand-blue-3)]"
    >
      {'<'}
    </button>
  )
}
